<template>
<div class="card">
    <div class="card-body help-card-body">
       <div class="text-center">
            <h4>Military Service</h4>
        </div>
        <hr>
        <p><b>Collect your assets:</b>
          <ul>
            <li> Get a copy of your Verification of Military Experience and Training through the Department of Defense. Your VMET will give an overview of the skills you've gained in the military.</li>
            <li>Make a list of your technical skills. Computer technicians, mechanics and engineers have skills that can be easily converted to civilian jobs. Convert your military job training into civilian terms. For example, “budgeting” is a critical skill in civilian companies.</li>
            <li>Make a list of your intangible skills. Include leadership, discipline and a strong work ethic.</li>
          </ul>
          <b>Translate everything into civilian terms.</b>
          <ul>
            <li>For example, replace “officer in charge” with “managed.”</li>
            <li>Take out the acronyms and use terms civilians understand. For example, replace "SNOIC for 2d MarDiv G-3, planning and executing all logistics for operations conducted in our AOR." with "Supervised staff of 15 people. Planned and coordinated operations conducted by various subordinate units within our division."</li>
            <li> Include your accomplishments. Use numbers to highlight, if possible. For example, "Managed budget of $100K" or "Reduced training time from 26 weeks to 24 weeks."</li>
          </ul>
        </p>
    </div>
</div>
</template>

<script>

export default {
  name: 'military',
  components: {

  },
  data() {
    return {

    }
  },
  methods: {

  }
}
</script>

<style>

</style>
